import $tool from './tool'

const utm = {
    install(Vue) {
        Vue.prototype.$getUtm = getUtm;

        function getUtm(vm) {
            // utm字段
            let utmObj = {
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_content: '',
                utm_term: ''
            };

            // 获取utm字段，任意一个字段有值，把所有的值都替换，都无值的时候，取现有cookie
            let utm_source = $tool.getUrlPara('utm_source') || '';
            let utm_medium = $tool.getUrlPara('utm_medium') || '';
            let utm_campaign = $tool.getUrlPara('utm_campaign') || '';
            let utm_content = $tool.getUrlPara('utm_content') || '';
            let utm_term = $tool.getUrlPara('utm_term') || '';

            if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
                utmObj = {
                    utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,
                    utm_content: utm_content,
                    utm_term: utm_term
                };
                $tool.setCookie('utmObj', JSON.stringify(utmObj));
            } else {
                if ($tool.getCookie('utmObj')) {
                    utmObj = JSON.parse($tool.getCookie('utmObj'));
                }
            }

            utmObj.modulesources = $tool.getUrlPara('linksourcemodule') || vm.pageRecord?.module || '';
            Vue.prototype.$utm = utmObj;
            return utmObj
        }
    }
};

export default utm
